const localStorageJWTManager = () => {
    const getToken = () => localStorage.getItem('token');

    const setToken = data => {
        localStorage.setItem('token', data);
        return true;
    };

    const eraseToken = () => {
        localStorage.removeItem('token');
        return true;
    };

    const getRefreshToken = () => localStorage.getItem('refreshToken');

    const setRefreshToken = data => {
        localStorage.setItem('refreshToken', data);
        return true;
    };

    const eraseRefreshToken = () => {
        localStorage.removeItem('refreshToken');
        return true;
    };

    const getUserEmail = () => localStorage.getItem('userEmail');

    const setUserEmail = data => {
        localStorage.setItem('userEmail', data.email);
        return true;
    };

    const eraseUserEmail = () => {
        localStorage.removeItem('userEmail');
        return true;
    };

    const getUserRoles = () => JSON.parse(localStorage.getItem('userRoles'));

    const setUserRoles = data => {
        localStorage.setItem('userRoles', JSON.stringify(data.roles));
        return true;
    };

    const eraseUserRoles = () => {
        localStorage.removeItem('userRoles');
        return true;
    };

    const getRedirectAfterLogin = () => localStorage.getItem('redirectAfterLogin');
    const setRedirectAfterLogin = url => {
        if (url) {
            localStorage.setItem('redirectAfterLogin', url);
        }

        return true;
    };
    const eraseRedirectAfterLogin = () => {
        localStorage.removeItem('redirectAfterLogin');
        return true;
    };

    const getUpdateLanguageAfterLogin = () => localStorage.getItem('updateLanguageAfterLogin');
    const setUpdateLanguageAfterLogin = language => {
        localStorage.setItem('updateLanguageAfterLogin', language);
        return true;
    };
    const eraseUpdateLanguageAfterLogin = () => {
        localStorage.removeItem('updateLanguageAfterLogin');
        return true;
    };

    return {
        eraseToken,
        getToken,
        setToken,
        eraseRefreshToken,
        getRefreshToken,
        setRefreshToken,
        getUserEmail,
        setUserEmail,
        eraseUserEmail,
        getUserRoles,
        setUserRoles,
        eraseUserRoles,
        getRedirectAfterLogin,
        setRedirectAfterLogin,
        eraseRedirectAfterLogin,
        getUpdateLanguageAfterLogin,
        setUpdateLanguageAfterLogin,
        eraseUpdateLanguageAfterLogin,
    };
};

export default localStorageJWTManager();
